import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef} from "@angular/core";
import {IIntPaginatorTogglePayload} from "./types";

@Component({
  selector: 'int-paginator',
  templateUrl: './int-paginator.component.html',
  styleUrls: ['./int-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntPaginatorComponent implements OnInit{
  @Input() entriesPerView = 1;
  @Input() entriesAmount = 1;
  @Input() maxControls = 1;
  @Input() activeControl = 1;
  @Input() prevLabel = '...';
  @Input() nextLabel = '...';
  @Input() directionAxis = 'row';

  @Input() itemContent!: TemplateRef<any>;
  //
  // // tslint:disable-next-line:variable-name
   _activeControl!: number;
  // // tslint:disable-next-line:variable-name
  _itemsSequence: number[] = [];
  // // tslint:disable-next-line:variable-name
  _entries: number[] = [];
  //
  @Output() toggle = new EventEmitter<IIntPaginatorTogglePayload>();
  //
  paginationData: IIntPaginatorTogglePayload[] = [];
  //
  constructor() {
    this._activeControl = this.activeControl;
  }
  get directionAxisValue(): string {
    return this.directionAxis;
  }
  //
  getPagesAmount(): number {
    return Math.ceil(this.entriesAmount / this.entriesPerView);
  }
  //
  clickOnPaginationItem(entryData: IIntPaginatorTogglePayload): void {
    this._activeControl = entryData.entryId;
    this.createPaginationData(this._activeControl);
    this.toggle.emit({...entryData});
  }
  //
  getItemsSequence(id: number): any {
    const pagesAmount = this.getPagesAmount();
    const start = Math.max(
      Math.min(id - 1, pagesAmount - this.maxControls)
      , 0);
    const stop = Math.min(id - 1 + this.maxControls + (id === 0 ? 1 : 0), pagesAmount);

    return this._entries.slice(start, stop);
  }
  //
  createPaginationData(id: number): void {

    this._itemsSequence = this.getItemsSequence(id);

    const pagesAmount = this.getPagesAmount();
    const prevSequence = [];
    const nextSequence = [];
    const lastSequenceEntry = this._itemsSequence[this._itemsSequence.length - 1];

    if (pagesAmount <= 1) {
      this.paginationData = [];
      return;
    }
    this.paginationData = [];
    const entries = this._itemsSequence.map((_, i) => {
      return {
        label: _ + 1,
        entryId: _,
        isActive: _ === this._activeControl
      };
    });

    if (this._itemsSequence[0] >= 1 && this._itemsSequence[0] < 2) {
      prevSequence.push({
        label: this.prevLabel,
        entryId: this._itemsSequence[0],
      });
    }

    if (this._itemsSequence[0] >= 2) {
      prevSequence.push({
        label: 1,
        entryId: 0,
      });
      prevSequence.push({
        label: this.prevLabel,
        entryId: this._itemsSequence[0] - 1,
      });
    }
    if ( (pagesAmount - 1) - lastSequenceEntry === 1 ) {
      nextSequence.push({
        label: this.nextLabel,
        entryId: lastSequenceEntry + 1,
      });
    }

    if (lastSequenceEntry < pagesAmount - 2) {
      nextSequence.push({
        label: this.nextLabel,
        entryId: lastSequenceEntry + 1,
      });
      nextSequence.push({
        label: pagesAmount,
        entryId: pagesAmount - 1,
      });
    }
    this.paginationData = [...prevSequence, ...entries, ...nextSequence];
  }
  ngOnChanges(): void {
    this._activeControl = Math.max(Math.min(this.activeControl - 1, this.getPagesAmount() - 1), 0);
    this._entries = Array(this.entriesAmount).fill(1).map((_, inx) => inx );
    this.createPaginationData(this._activeControl);
  }
  ngOnInit(): void {}
}
